/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export { ajax } from '../internal/observable/dom/ajax';
export { AjaxResponse, AjaxError, AjaxTimeoutError } from '../internal/observable/dom/AjaxObservable';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/ajax/index.js
// module id = 2700
// module chunks = 2